/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */
import { cleanUpKey } from 'utils/common';

const apiPath = (api) => {
  if (api) {
    return cleanUpKey(`${api.info.title}_${api.info.version}`);
  }
};

const eventPath = (api, channelName, where) => {
  let path = '';
  if (api) path += `/${apiPath(api)}`;
  if (channelName) path += `/${encodeURIComponent(channelName)}`;
  if (where) path += `/${where}`;
  return path;
};

const decodeChannelName = (channel) => decodeURIComponent(channel);

const getCurrentItemFromPath = (pathname) => {
  const splitPath = pathname.split('/');
  let selectedItem = '';
  // documentation checks
  switch (splitPath[1]) {
    case 'documentation':
      selectedItem = `${splitPath[2]}_${splitPath[splitPath.length - 1]}`;
      break;
    default:
      break;
  }

  // api checks
  switch (splitPath[2]) {
    case 'overview':
      selectedItem = 'overview';
      break;
    case 'operation':
      selectedItem = `${decodeURIComponent(splitPath[3])}_${splitPath[4]}`;
      break;
    case 'definitions':
      selectedItem = 'definitions';
      break;
    case 'documentation':
      // apiname + 'documentation' + doc name + last doc name
      selectedItem = `${splitPath[1]}_${splitPath[2]}_${splitPath[3]}_${splitPath[splitPath.length - 1]}`;
      break;
    case 'webhook':
      selectedItem = `${splitPath[1]}_${splitPath[2]}_${splitPath[splitPath.length - 1]}`;
      break;
    default:
      break;
  }
  // channel checks
  switch (splitPath[3]) {
    case 'overview':
      selectedItem = `${decodeURIComponent(splitPath[2])}_overview`;
      break;
    case 'operation':
      selectedItem = `${decodeURIComponent(splitPath[2])}_${decodeURIComponent(splitPath[4])}`;
      break;
    case 'publish':
      selectedItem = `${decodeURIComponent(splitPath[2])}_data`;
      break;
    case 'subscribe':
      selectedItem = `${decodeURIComponent(splitPath[2])}_data`;
      break;
    default:
      break;
  }
  return selectedItem;
};

const getApi = (apis, apiName) => apis.find((api) => apiPath(api) === apiName);

export { apiPath, getCurrentItemFromPath, getApi, eventPath, decodeChannelName };
